import { render } from "./BloodSugar.vue?vue&type=template&id=41850736"
import script from "./BloodSugar.vue?vue&type=script&lang=js"
export * from "./BloodSugar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__